// extracted by mini-css-extract-plugin
module.exports = {"mainFormContanier":"Contact_mainFormContanier__3xoUN","formDetailsContainer":"Contact_formDetailsContainer__2_5dD"};